import { createUseStyles } from 'react-jss';

import { ITheme } from 'types';
import {
  overlayStyles,
  choiceStyles,
} from 'components/common/Modals/defaultStyles';

const useStyles = createUseStyles<ITheme>(theme => ({
  downloadModalOverlay: overlayStyles,
  downloadModal: {
    left: '50%',
    top: '50%',
    position: 'absolute',
    padding: theme.spacings.s32,
    border: `2px solid ${theme.colors.backgrounds.tint3}`,
    borderRadius: theme.radiuses.r8,
    minWidth: 500,
    maxHeight: '90vh',
    overflow: 'auto',
    pointerEvents: 'auto',
    display: 'grid',
    gridGap: theme.spacings.s16,
    transform: 'translate(-50%, -50%)',
    background: theme.colors.backgrounds.tint2,
    boxShadow: `0 0 8px ${theme.colors.shadows.tint1}`,
    height: 'auto',
  },
  downloadFooter: {
    ...choiceStyles,
    display: 'grid',
    justifyContent: 'end',
    gridAutoFlow: 'column',
    gap: theme.spacings.s12,
    marginTop: theme.spacings.s16,
  },
  surveyLink: {
    '@media(hover: hover)': {
      '&:hover': {
        textDecoration: 'underline !important',
        color: theme.colors.accents.secondary.base.action,
      },
    },
  },
  driveLink: {
    '& a': {
      color: theme.colors.accents.secondary.base.action,
      '@media(hover: hover)': {
        '&:hover': {
          textDecoration: 'underline !important',
        },
      },
    },
  },
  downloadCloseButton: {
    position: 'absolute',
    right: theme.spacings.s12,
    top: theme.spacings.s12,
    cursor: 'pointer',
    color: theme.colors.texts.negative,
    verticalAlign: 'top',
    display: 'inline-block',
    backgroundColor: theme.colors.backgrounds.tint5,
    borderRadius: theme.radiuses.circle,
    width: 20,
    height: 20,
    '& path': {
      fill: theme.colors.backgrounds.base,
    },
  },
}));

export default useStyles;
